import IconChevronRight from 'assets/icons/chevron-right-stroke.svg';
import cn from 'classnames';
import { NavigationItem } from 'interfaces/navigation-data';
import Link from 'next/link';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { useRootStore } from 'stores/use-root-store';
interface INavigationLink {
  children?: React.ReactNode;
  className?: string;
  item: NavigationItem;
  useItemWrapper?: boolean;
  onClick?: () => void;
}

const NavigationLink: React.FC<INavigationLink> = ({
  item,
  children,
  className,
  useItemWrapper = true,
  onClick = () => {},
}) => {
  const petType = useRootStore((store) => store.petType);
  const NavItemWrapper = ({ children }): ReactNode => {
    if (!useItemWrapper) return <div className="w-full">{children}</div>;

    switch (item.itemType) {
      case 'targeted':
        return (
          <a
            data-test={`nav-${petType}-${item.title}`}
            href={item.url}
            target={item.target}
            className="w-full"
            onClick={onClick}
            key={item.title}
          >
            {children}
          </a>
        );
      case 'card':
        return <div className="px-4 py-2">{children}</div>;
      case 'entry':
        return (
          <Link passHref href={item.url} key={item.title}>
            {children}
          </Link>
        );
      case 'nested-card':
        return <div className="px-4">{children}</div>;
      case 'nested-entry':
        return (
          <button data-test={`nav-${petType}-${item.title}`} className="w-full" key={item.title}>
            {children}
          </button>
        );
      default:
        return <></>;
    }
  };

  return (
    <NavItemWrapper>
      {item.dividerTop && <div className="bg-grey-300 h-px w-full" />}
      <div
        data-test={`nav-${petType}-${item.title}`}
        className={cn(
          'bg-other-white text-primary-main relative flex w-full cursor-pointer items-center justify-between rounded-sm px-4 py-2 focus:outline-hidden',
          item.itemType === 'card' || (item.itemType === 'nested-card' && 'h-16'),
          (item.itemType === 'card' || item.itemType === 'nested-card') &&
            'border-grey-50 rounded-lg border-2',
          className
        )}
        style={
          item.itemType === 'card' || item.itemType === 'nested-card'
            ? {
                ...(item.itemType === 'card' || item.itemType === 'nested-card'
                  ? {
                      backgroundImage: `url(${item.src})`,
                    }
                  : {}),
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center right',

                // toggle here if the card image is covering the card, which is provided to us by marketing team.
                // backgroundSize: 'cover',
                // backgroundPosition: 'center',
              }
            : {}
        }
        onClick={onClick}
      >
        {children ?? (
          <>
            <div
              className={cn(
                'flex items-center',
                (item.itemType === 'nested-card' || item.itemType === 'card') &&
                  'text-primary-main',
                item.itemType === 'entry' && item.reducedTextSize && 'text-xs! font-normal'
              )}
            >
              <FormattedMessage id={item.title} />
            </div>
            {item.itemType === 'entry' ? (
              item.src ? (
                <img src={item.src} alt={`Product: ${item.title}`} className="h-12 w-12" />
              ) : null
            ) : (
              <IconChevronRight className="text-primary-main h-8 w-6" />
            )}
          </>
        )}
      </div>
      {item.dividerBottom && <div className="bg-grey-300 h-px w-full" />}
    </NavItemWrapper>
  );
};

export default NavigationLink;
